import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var KeyBackspace = function KeyBackspace(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 12 : _ref$height;
  return /*#__PURE__*/_jsx("svg", {
    width: width,
    height: height,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M7 4L9 6M9 6L11 8M9 6L11 4M9 6L7 8M4.62143 1H15V11H4.62143L1 6L4.62143 1Z",
      stroke: "currentColor",
      strokeWidth: "1.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};